export default __webpack_public_path__ + "static/media/rick.195c02ac.png";